export const services = [
  {
    Assignment: 'device',
    Code: 'MOBILE_APP',
    Date: '2022-06-01T00:00:00Z',
    Groups: ['ru'],
    Id: 'MOBILE_APP_RU',
    Name: 'APP/QR',
    PurchaseInfo: {
      Currency: 'RUB',
      PaymentType: 0,
      Price: 100,
      PurchaseDay: 1
    },
    Desc: "За оборудование удерживается 100p в месяц за сервис ОПЛАТА ЧЕРЕЗ ПРИЛОЖЕНИЕ И/ИЛИ QR КОД Если у вас нет необходимости в использовании этого сервиса для конкретного аппарата - вам необходимо установить переключатель 'Оплата через приложение' в разделе редактирования конкретного аппарата"
  },
  {
    Assignment: 0,
    Code: 'MONI_PRO',
    Date: '2024-10-01T00:00:00Z',
    Groups: ['ru'],
    Id: 'MONI_PRO_RU',
    Name: 'Base',
    PurchaseInfo: {
      Currency: 'RUB',
      PaymentType: 0,
      Price: 200,
      PurchaseDay: 1
    },
    Desc: 'За оборудование удерживается 200p в месяц за сервис GPS-МОНИТОРИНГА КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ Если у вас нет необходимости в использовании этого сервиса для конкретного аппарата - вам необходимо удалить аппарат из системы. Для удаления - обратитесь в службу технической поддержки'
  }
];

export const options = {
  min: 933.34,
  max: 14999,
  amount: 6000.03,
  amount_currency: 'KZT'
};
